import ProjectDetail from "src/domains/project/components/ProjectDetails";

import ProjectsList from "./list";

const ProjectPage = () => <ProjectDetail />;

export default ProjectPage;
export { ProjectsList };
